// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/@girder/histomicsui/stylesheets/panels/metadataPlot.styl
// module id = 137
// module chunks = 0